<template>
	 <div class="dynamiclist qualityenterprise"> 
			<leftnav class="fl"  :itemcode="cur_page.itemcode"></leftnav> 
			<div class="index_left" :style="isCollapse?'margin-left: 0;width:100%':''"> 
				<govheader></govheader>
				<div class="index_left_centerpage">
					<div class="whitebox right_topbox" style="padding-bottom: 1px;">
						<div class="right_boxtitle">
							<span class="fl right_title">{{cur_page.title}}</span> 
							<p class="fl titlefont lh42" v-html="cur_page.titlefont"></p>
						</div> 
 
				</div>
				<div class="whitebox oh" style="min-height: 160px;padding-bottom:150px;">
					<!-- <div  border="0" cellspacing="0" cellpadding="0" class="enterprise_table mt-5"> -->
						<div class="ten-comparison-list w95mg flexcss" :key="i" v-for="(list,i) in  comparison_list">
							<!-- <div class="ten-comparison-index" :style="'line-height:'+index_lineheight">{{i+1}}</div> -->
							<div class="ten-comparison-title" :style="'padding-top:'+title_paddingtop" ><span class="title" @click="routerlinkid('/enterprises',list.baseInfo.stockCode)">{{list.baseInfo.title}}</span></div> 
							<div class="ten-comparison-content">
								<enterpriseTaglist class="company_tag_list" v-show="page_type == 1" v-if="page_type == 1 && list.baseInfo.tag!=''" :tagText="list.baseInfo.tag" :tag-code="list.baseInfo.tagCode"></enterpriseTaglist>
							 <div  v-show="page_type == 2" class="oh flexcss" data="2">
									<div v-show="list.revenue.data.length>0" class="echartbox echart-line-box" :style="'width:'+echartWidth2+'px;'"  :id="'businessincome'+(i+1)"></div>
									<div v-show="list.profit.data.length>0" class="echartbox echart-line-box" :style="'width:'+echartWidth2+'px;'"  :id="'netprofit'+(i+1)"></div>
								</div>
								<div  v-show="page_type == 3" class="oh flexcss" data="3">
									<div v-show="list.land.length>0" class="echartbox echart-line-box" :style="'width:'+echartWidth2+'px;'"  :id="'nadimianji'+(i+1)"></div>
									<div v-show="list.land.length>0" class="echartbox echart-line-box" :style="'width:'+echartWidth2+'px;'"  :id="'nadishuliang'+(i+1)"></div>
								</div>
								<div  v-show="page_type == 4" class="oh flexcss" data="4">
									<div v-show="list.landInfo.cityList.length>0" class="echartbox echart-line-box" :style="'width:'+echartWidth2+'px;'"  :id="'nadiquyumianji'+(i+1)"></div>
									<div v-show="list.landInfo.cityList.length>0" class="echartbox echart-line-box" :style="'width:'+echartWidth2+'px;'"  :id="'nadiquyushuliang'+(i+1)"></div>
								</div>
								<div class="enterprise_zsldt" v-show="page_type == 5" style="min-height: 320px;">
									<enterpriseNotionGrade v-if="switchBtn" :listData="list.radarList"  data="5"></enterpriseNotionGrade>
								</div> 
							</div>
							<div class="ten-comparison-index" :style="'line-height:'+index_lineheight"><span class="fwb cur-pointer"  @click="routerblank('/enterprises?id='+list.baseInfo.stockCode+'&ctitle='+cur_page.ctitle)">详情></span></div>
						</div> 
						<p class="orangefont w95mg mt-5 pl-10 fz20">此模块列出的10家样板公司信息，只是作为参考案例，想说明：通过哪些维度信息，可以对企业实力或意向做出什么判断<br>您可以参考这些信息维度，来判断其他企业的实力和投资意向</p>
					<!-- </div> -->
				</div> 
			</div>
		</div>
	</div>
</template>

<script>
	import enterpriseTaglist from "@/components/enterpriseInc/enterprise-tag-list.vue"
	import enterpriseNotionGrade from "@/components/enterpriseInc/enterprise-notion-grade.vue"
	// import top10data from "https://lian.ocn.com.cn/static/data/top10.js"
	import { mapState, mapMutations, mapGetters } from "vuex";

	export default {
		name: 'ten-enterprises-comparison',
		computed: {
		...mapState({
			isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
	},
		data: function(){
			return{
				userdata:{},
				curWebsite:this.$api.getWebsiteType(),  	
				index_lineheight:"180px",
				title_paddingtop:"70px",
				title: '上市公司在本市投资项目',	 
				echartWidth2:(document.body.offsetWidth*0.8728*0.95 - 400)*0.48,
				page_type:1,
				curstep:"0",
				switchBtn:false, 
				cur_page:{
					title:"判断企业综合实力",
					type:1,itemcode:"PD-ZHSL",
					titlefont:"通过企业的综合实力、技术实力和投资实力标签，判断企业的实力。",
					ctitle:"company-tag", 
				},
				page_list:[
					{title:"判断企业综合实力",step:1,type:1,itemcode:"PD-ZHSL",titlefont:"通过企业的综合实力、技术实力和投资实力标签，判断企业的实力。",ctitle:"company-tag"},
					{title:"判断企业财务实力",step:2,type:2,itemcode:"PD-CWSL",titlefont:"通过企业营业收入、净利润，判断企业的财务实力和经营稳健性。",ctitle:"jyzk",},
					{title:"了解企业投资动态",step:2,type:3,itemcode:"PD-TZDT",titlefont:"通过企业历年拿地面积和拿地数量，分析企业的投资动态，识别企业的投资窗口期。",ctitle:"land-pie-block"},
					{title:"了解企业投资布局",step:2,type:4,itemcode:"PD-TZBJ",titlefont:"",ctitle:"land-map-block"},
					{title:"判断企业投资意向",step:2,type:5,itemcode:"PD-TZYX",titlefont:"",ctitle:"invest-algorithm"},
				],
    comparison_list:[
					// {title:"宁德时代新能源科技股份有限公司",stockCode:'300750',companyInfor:{tag:"",tagCode:""},jinlirun:{data:[]},yingye:{data:[]},landlist:[],landInfo:{cityList:[]}},
					// {title:"杭州海康威视数字技术股份有限公司",stockCode:'002415',companyInfor:{tag:"",tagCode:""},jinlirun:{data:[]},yingye:{data:[]},landlist:[],landInfo:{cityList:[]}},
					// {title:"晶澳太阳能科技股份有限公司",stockCode:'002459',companyInfor:{tag:"",tagCode:""},jinlirun:{data:[]},yingye:{data:[]},landlist:[],landInfo:{cityList:[]}},
					// {title:"新疆金风科技股份有限公司",stockCode:'002202',companyInfor:{tag:"",tagCode:""},jinlirun:{data:[]},yingye:{data:[]},landlist:[],landInfo:{cityList:[]}},
					// {title:"京东方科技集团股份有限公司",stockCode:'000725',companyInfor:{tag:"",tagCode:""},jinlirun:{data:[]},yingye:{data:[]},landlist:[],landInfo:{cityList:[]}},
					// {title:"深圳迈瑞生物医疗电子股份有限公司",stockCode:'300760',companyInfor:{tag:"",tagCode:""},jinlirun:{data:[]},yingye:{data:[]},landlist:[],landInfo:{cityList:[]}},
					// {title:"中兴通讯股份有限公司",stockCode:'000063',companyInfor:{tag:"",tagCode:""},jinlirun:{data:[]},yingye:{data:[]},landlist:[],landInfo:{cityList:[]}},
					// {title:"比亚迪股份有限公司",stockCode:'002594',companyInfor:{tag:"",tagCode:""},jinlirun:{data:[]},yingye:{data:[]},landlist:[],landInfo:{cityList:[]}},
					// {title:"江苏恒瑞医药股份有限公司",stockCode:'600276',companyInfor:{tag:"",tagCode:""},jinlirun:{data:[]},yingye:{data:[]},landlist:[],landInfo:{cityList:[]}},
					// {title:"上海韦尔半导体股份有限公司",stockCode:'603501',companyInfor:{tag:"",tagCode:""},jinlirun:{data:[]},yingye:{data:[]},landlist:[],landInfo:{cityList:[]}},
				],
				colors: ['#5E83CC', '#ffbb1c', '#47a59d', "#3975b8"], 
			};
		},
		watch: {
			$route: function(newVal, oldVal) {   
				this.getCurPage()
			}
		},
		components:{
			enterpriseTaglist,enterpriseNotionGrade
		},
		created() { 
			this.$nextTick(() => {
				// 禁用右键
				document.oncontextmenu = new Function("event.returnValue=false");
				// 禁用选择
				document.onselectstart = new Function("event.returnValue=false");
			});
				this.userdata = this.getuserinformain(); 
				this.comparison_list=top10;
				
				// this.bus.$emit('loading', true);
		},
	 
		mounted() {
			console.log('top10',top10);
		this.getCurPage();
		if(this.userdata.edition<1){
			var _this=this;
				alert('升级版本后即可查看本页面,自动跳转');
			setTimeout(function(){
				_this.routerself('/totalEnterprises');
			},1000)
			return;
		}  
		},
		methods:{
  //获取当前页面的值后调取信息刷新页面
			getCurPage(){
					this.page_type = this.$route.query.type ? this.$route.query.type : 1; 
					var type=this.page_type;
					let arry=this.page_list.filter(list=>{
						return list.type == type;
					});
					this.cur_page=arry[0];
					if(this.page_type == 1){
						this.index_lineheight='180px';
						this.title_paddingtop='70px';
					}else if(this.page_type == 2 || this.page_type == 3 || this.page_type == 4){
						this.index_lineheight='320px';
						this.title_paddingtop='140px';
					}else if(this.page_type == 7){
						this.index_lineheight='380px';
						this.title_paddingtop='170px';
					}
					var _this=this;
					for(var i=0;i<top10.length;i++){ 
						if(this.page_type == 2){   
								this.jinliruBar('businessincome'+(i+1),top10[i].revenue); //营业收入
								this.jinliruBar('netprofit'+(i+1),top10[i].profit);//净利润  
						}else if(this.page_type == 3){ 
							this.linechartfun('nadimianji'+(i+1),top10[i].land,'land',1,'历年拿地面积','亩');//拿地信息面积折线图   
							this.linechartfun('nadishuliang'+(i+1),top10[i].land,'land',2,'历年拿地数量','块'); //拿地信息数量折线图 
						}else if(this.page_type == 4){ 
							this.chianmapFun('nadiquyumianji'+(i+1),top10[i].landInfo.cityList,'land',1,'拿地面积区域分布');;//拿地信息区域地图   
							this.chianmapFun('nadiquyushuliang'+(i+1),top10[i].landInfo.cityList,'land',2,'拿地数量区域分布');;//拿地信息区域地图   
						 
						}else if(this.page_type == 5){ }
						this.switchBtn=true;
						
					}
					this.$axios.get(this.$api.cyl.enterprise.comparison(), {
						headers: {
							AuthToken: this.userdata.token
						}
					}).then(function(res) {  });  
			},
 
			sortKey(array,key,type){
				return array.sort(function(a,b){
					var x = a[key];
					var y = b[key];
					if(type == 1){
							return ((x>y)?-1:(x<y)?1:0)//正序从大到小
					}else{
						return ((x<y)?-1:(x>y)?1:0)//正序从小到大
					} 
				})
			}, 
			//历年拿地数据
			linechartfun(el,data,type,type1,title,unit){
				if(!data || data.length<1){
					return;
				}
					var mylinechart = echarts.init(document.getElementById(el));
					var xdata=[],ydata=[];
					var serdata=this.lineReturnData(data,type,type1); 
					for(var n =0;n<serdata.length;n++){
						xdata.push(serdata[n].name);
						ydata.push(serdata[n].value);
					} 
					var timeunit=type1>2?'月':'年';
					// console.log(xdata,ydata); 
						var	option = {
							title:{
								text:title,
								bottom:5,left:'center',
								textStyle:{fontWeight:"normal",fontSize:16}
							},
								color: ['#5E83CC', '#ffbb1c', '#47a59d', "#f60", "#ff0", "#f87f8f"],
								// tooltip: {
								// 	trigger: 'item'
								// },
								tooltip: {
									trigger: 'item',
									backgroundColor: 'rgba(255,255,255,0.9)',
									borderColor: '#ddd',
									borderWidth: '1',
									textStyle: {
									color: '#000',
									fontSize: 14, 
									}, 
									formatter: function(params) { 
										let rethtml = params.marker + params.name + timeunit+title+"：" + params.value +unit ;
										return rethtml;
									}
								},
								legend: {  
								show:true,
								bottom:10,
								},
								label: {show: true },
							  xAxis: {
							    type: 'category',
							    data: xdata,
							  },
							  yAxis: {
							    type: 'value',
											name: title.substring(2,4)+'（'+unit+'）',
							  },
							  series: [
							    {
												name:'',
							      data: ydata,
							      type: 'line',
													smooth: true
							    }
							  ]
							};
							mylinechart.setOption(option); 
			},
			//拿地数据抽取时间
			//type用于区分项目和拿地 他们的date值名字不一样 type1用于区分面积/金额和数量 他们的参数名字也不一样
			lineReturnData(data,type,type1){ 
			
				//折线图 将时间提取出来 
				 var serdata=[];//todo 每个月要进行更新 updatetime
				 let yeararry=['2023-02','2023-03','2023-04','2023-05','2023-06','2023-07','2023-08','2023-09','2023-10','2023-11','2023-12','2024-01',];
					let yearstr=yeararry.join("%");
					var yeardata=[];
					for(var i=0;i<yeararry.length;i++){
						yeardata.push({name:yeararry[i],value:0});
					}
					if(type1>2){
						//近期 从现实推算到一年的数据 
						
						for(var i=0;i<data.length;i++){
							if(type=='land'){
								data[i].datetime=data[i].time.substring(0,7);   
								data[i].Linevalue=data[i].size; 
							}else if(type=='project'){
								data[i].datetime=data[i].date.substring(0,7); 
								data[i].Linevalue=data[i].money/10000; 
							}else if(type== 'finance'){
								data[i].datetime=data[i].date.substring(0,7);
								data[i].Linevalue=data[i].money/10000; 
							}
						} 
						data=data.filter(list=>{
							 return yearstr.indexOf(list.datetime)>-1;
						})
						console.log('yeardata0',data)
					}else{
						for(var i=0;i<data.length;i++){
							if(type=='land'){
								data[i].datetime=data[i].time.substring(0,4);   
								data[i].Linevalue=data[i].size; 
							}else if(type=='project'){
								data[i].datetime=data[i].date.substring(0,4); 
								data[i].Linevalue=data[i].money/10000; 
							}else if(type== 'finance'){
								data[i].datetime=data[i].date.substring(0,4);
								data[i].Linevalue=data[i].money/10000; 
							}
						} 
					}
					
					
				 var Num=[0];//存储数据出现的次数
				 var str=[0];//存储不重复的数据， 
				 var amountArry=[0];//存储不重复的数据， 
				 var x=0;
				 for(var i=0;i<data.length;i++){
				     var temp=data[i].datetime//将要统计的数据赋值给temp
									var Linevalue1=data[i].Linevalue; 
				     var Num1=1;
				     for(var j=i+1;j<data.length;j++){
				         if(temp==data[j].datetime){//若数组后续中的数据与temp相同时，进行该代码段
				             Num1++;//项目/拿地数量叠加
																	Linevalue1+=data[j].Linevalue;//拿地面积和项目金额叠加 上面已经将参数值统一了
				         }
				     }
				     var answer=(str.indexOf(temp)>-1)//判断str数组中是否含有temp数据，存在返回true否则false
				     if(!answer){//若数据不存在时，进行此程序，将数据存储起来
				         str[x]=temp//str与Num的下角标互相对应
				         Num[x]=Num1
				         amountArry[x]=Linevalue1;
				         x++
				     }
				 }
				 // console.log("数组str的长度为："+str.length+"</br>"); 
				 for(var k=0;k<str.length;k++){
				   // console.log("字符："+str[k]+" 出现次数为："+Num[k]+"</br>");  
							if(type1 == 1 || type1 == 3){
								serdata.push({name:str[k],value:amountArry[k].toFixed(1) });
							}else if(type1 == 2|| type1 == 4){
								serdata.push({name:str[k],value:Num[k]});
							} 
				 		this.sortKey(serdata,'name',2);  
				 } 
					if(type1>2){
						for(var i=0;i<serdata.length;i++){
							let serMonth=serdata[i].name;
							for(var d=0;d<yeardata.length;d++){
								if(serMonth == yeardata[d].name){
									yeardata[d].value=serdata[i].value;
								} 
							}  
						} 
						serdata=yeardata;
					}
				return serdata; 
			},
			//经营利润线形图
			jinliruBar($el,data){
				if(data.data.length == 0){
					return;
				}
				var chart = echarts.init(document.getElementById($el));
				var _this = this;
				let option = {
					title:{
						text:data.name,
						bottom:5,left:'center',
						textStyle:{fontWeight:"normal",fontSize:16}
					},
					tooltip: {
						trigger: 'item',
						backgroundColor: 'rgba(255,255,255,0.9)',
						borderColor: '#ddd',
						borderWidth: '1',
						textStyle: {
						color: '#000',
						fontSize: 14, 
						}, 
						formatter: function(params) { 
							let rethtml = params.marker + params.name + "年"+data.name+"：" + params.value +data.unit ;
							return rethtml;
						}
					},
					xAxis: {
						type: 'category',
						data: data.date,
					},
					color: _this.colors,
					yAxis: {
						type: 'value',
						name: '单位：'+data.unit,
					},
					series: [{
						data: data.data,
						type: 'bar',
						barWidth:24,
					}]
				};
				chart.setOption(option);
				
			},
			//区域分布地图
			chianmapFun(el,data,type,type1,title){
				if(data.length<1){
					return ;
				}
				// console.log('拿地项目地图分布',el,data);
				var myChart = echarts.init(document.getElementById(el)); 
				myChart.showLoading({
					text: 'loading',
					color: '#3A568E',
					textColor: '#000',
					maskColor: 'rgba(255, 255, 255, 1)',
					zlevel: 1,
				}); 
				var loadedDataURL ='map/china.json'; 
				// 注意引入版本 
				var geoCoordMap = this.$geoJson; 
				var _this=this;
				$.getJSON(loadedDataURL, function (geoJson) { 
				  // 注册地图名字(tongren)和数据(geoJson) 
				  echarts.registerMap('china', geoJson);  
						var scaData=[],maptitle='',symbolSizeData=[],testdata=[]; 
						for (var i = 0; i < data.length; i++) {
						    var geoCoord = geoCoordMap[data[i].name];
										// console.log(geoCoord)
						    if (geoCoord) { 
											var value1=[], scdataSm={};  
											if(type1 == 2){
												value1=geoCoord.concat(data[i].value);//通过数量分布显示光圈大小
											}else{
												if(type=='land'){
														value1=geoCoord.concat(data[i].size.toFixed(2))//通过拿地面积分布显示光圈大小
												}else{
													 value1=geoCoord.concat(( data[i].money/10000).toFixed(2))//通过项目金额分布显示光圈大小
												} 
											} 
											if(type=='land' ){  
												scdataSm={ name: data[i].name, value: value1, areaId: data[i].areaId, money: data[i].money,num: data[i].value,size: data[i].size.toFixed(2)}
											}else if(type == 'project'){ 
													scdataSm={name: data[i].name, value: value1, areaId: data[i].areaId, money: ( data[i].money/10000).toFixed(2),num: data[i].value,}
											} 
												scaData.push(scdataSm); 
						    }
									
						} 
						var repeatNum=0,a1=[{value:scaData[0].value[2],index:0}];
							for(var i=1;i<scaData.length;i++){ 
								if(scaData[i].value[2] != scaData[i-1].value[2]){
									repeatNum++;
								}
							var a2={value:scaData[i].value[2],index:repeatNum};
							a1.push(a2);
						} 
						if(title.indexOf('面积')>0){
							console.log('repeatNum',repeatNum)
							for(var i=0;i<a1.length;i++){
								let size=(repeatNum - a1[i].index+1)*1;
								if(repeatNum<5){
									console.log(repeatNum,'<5')
									size=(repeatNum - a1[i].index+1)*3;
								}else if(4 < repeatNum && repeatNum <10){
									size=(repeatNum - a1[i].index+1)*2;
								}else if(9 < repeatNum && repeatNum<15){
									size=(repeatNum - a1[i].index+1)*1.5;
								}else if(14 < repeatNum && repeatNum<25){
									size=parseInt((repeatNum - a1[i].index+1)*0.6)
								}else if(24 < repeatNum && repeatNum<35){
										size=parseInt((repeatNum - a1[i].index+1)*0.5);
								}else if(34 < repeatNum && repeatNum<45){
										size=parseInt((repeatNum - a1[i].index+1)*0.4);
								}else if(44 < repeatNum && repeatNum<55){
										size=parseInt((repeatNum - a1[i].index+1)*0.3);
								}else if(54 < repeatNum && repeatNum < 99){
										size=parseInt((repeatNum - a1[i].index+1)*0.2);
								}else if(98 < repeatNum){
										size=parseInt((repeatNum - a1[i].index+1)*0.2);
								}    
									symbolSizeData.push(size); 
							}
						}else{
							for(var i=0;i<a1.length;i++){
								let size=(repeatNum - a1[i].index+1)*1;
								if(repeatNum<5){
									size=(repeatNum - a1[i].index+1)*2+8;
								}else if(4 < repeatNum && repeatNum <10){
									size=(repeatNum - a1[i].index+1)*2+3;
								}else if(9 < repeatNum && repeatNum<15){
									size=(repeatNum - a1[i].index+1)*2;
								}else if(14 < repeatNum && repeatNum<25){
									size=parseInt((repeatNum - a1[i].index+1)*1.8)
								}else if(24 < repeatNum && repeatNum<35){
										size=parseInt((repeatNum - a1[i].index+1)*1.3);
								}else if(34 < repeatNum && repeatNum<45){
										size=parseInt((repeatNum - a1[i].index+1)*1);
								}else if(44 < repeatNum && repeatNum<55){
										size=parseInt((repeatNum - a1[i].index+1)*0.8);
								}else if(54 < repeatNum && repeatNum < 99){
										size=parseInt((repeatNum - a1[i].index+1)*0.6);
								}else if(98 < repeatNum){
										size=parseInt((repeatNum - a1[i].index+1)*0.5);
								}    
									symbolSizeData.push(size); 
							}
						}
 
				var option = {
				    backgroundColor: '#fff',
				    title: {
				        text: title,
				        left: 'center',top:20,
				        textStyle: {
				            color: '#666',
				            fontSize:16
				        }
				    },
				    tooltip: {           //提示框组件
				        trigger: 'item',
				        formatter: function(params) {
				        	// console.log(params)
				        	return params.name;
				        },
				        show:true,
				    },
				
				    legend: {            //图例
				        orient: 'vertical',show:false,
				        y: 'bottom', 
				        x: 'right', 
				    },
				    geo: {
				        map: "china", 
												silent: true, 
												// layoutCenter: ['49%', '49%'],
												layoutSize: '100%',
				        roam: false,
				        center:[105.87,38],
				        zoom:1,
												label:{show:true,textStyle:{color:'#fff'}},
				        itemStyle: {
				            normal: {
				                areaColor: "#2e579d",
				                borderColor: "#fff"
				            },
				            emphasis: {
				                areaColor: "#fff"
				            }
				        }
				    },
				    series: [  
								{
				        name: '',
				        type: 'effectScatter',
				        coordinateSystem: 'geo',
				        data: scaData,    //选取从 start 到数组结尾的所有元素，该方法并不会修改数组，而是返回一个子数组 
				        symbolSize:function(val,ser){
													// console.log(val[2],title,ser.dataIndex)
													return symbolSizeData[ser.dataIndex];
													// return _this.mapSymbolSize(val,ser.dataIndex,symbolSizeData);
												},
				        showEffectOn: 'render',
				        rippleEffect: {
				            brushType: 'stroke'
				        },
												tooltip:{
													show:true,
													formatter: function(){},
												},
				        hoverAnimation: true,
				        label: {
				            normal: { 
				                formatter: '{b}:{@2}',
				                position: 'right',
				                show: false
				            },
				            emphasis: {
				                show: true
				            }
				        },
				        itemStyle: {
				            normal: {
				                color: '#f4e925',
				                shadowBlur: 10,
				                shadowColor: '#333'
				            }
				        },
				        zlevel: 1
				    },
								]
				}; 
				if(type == 'land'){
					option.series[0].tooltip.formatter=function(params) {
							var result = '<h3 style="font-size:15px;line-height:20px;margin-bottom:5px">'+params.name+'</h3>';
							if (!isNaN(params.data.money)) {
								result =result+'<div style="line-height:20px">拿地面积：' + params.data.size + ' 亩<br>拿地金额：' + params.data.money+ '万元<br>拿地记录：' + params.data.num+' 条</div>';
							} 
							// console.log(params);
							return result;
						}
				}else if(type == 'project'){
					option.series[0].tooltip.formatter=function(params) {
							var result = '<h3 style="font-size:15px;line-height:20px;margin-bottom:5px">'+params.name+'</h3>';
							if (!isNaN(params.data.money)) {
								result =result+'<div style="line-height:20px">投资项目数：' + params.data.value[2] + ' 个<br>投资金额：' + params.data.money+ ' 亿元</div>';
							} 
							// console.log(params);
							return result;
						}
				}
				myChart.hideLoading();
				myChart.setOption(option); 
				
			})
			}
		}
	}
</script>

<style></style>